import React, { useEffect, useState } from "react";
import { AppBar, Box, IconButton, Toolbar } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import DrawerNavbar from "./DrawerNavBar";
import AccountUser from "./account/AccountUser";
import useIsMobile from "../utils/hooks/useIsMobile";

export default function ResponsiveAppBar() {
  const isMobile = useIsMobile();
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    setMobileOpen(isMobile ? false : true);
  }, [isMobile]);

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  return (
    <>
      <AppBar sx={{ background: "#fff", display: { sm: "block", md: "none" }, zIndex: !mobileOpen && ((theme) => theme.zIndex.drawer + 1) }}>
        <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
          <Box>
            <IconButton color="primary" aria-label="open drawer" edge="start" onClick={handleDrawerToggle}>
              <MenuIcon />
            </IconButton>
          </Box>

          <Box xs={1} sx={{ display: { md: "block" } }}>
            <AccountUser />
          </Box>
        </Toolbar>
      </AppBar>

      <DrawerNavbar handleDrawerToggle={handleDrawerToggle} mobileOpen={mobileOpen} />
    </>
  );
}
